export default __webpack_public_path__ + "static/media/2-1-3.9176b6a1.jpg";